// Utility functions for formatting data

import { format, isSameDay, parseISO } from 'date-fns';

export const formatCurrency = (amount: number, currency: string = '€'): string => {
  return `${currency}${amount.toLocaleString()}`;
};

export const formatLocation = (
  hometown?: string | null,
  country?: string | null,
): string => {
  return [hometown, country].filter((part): part is string => Boolean(part)).join(', ');
};

/** Format event date range; end date is optional (single-day or open-ended events). */
export const formatEventDateRange = (
  startDate?: string | null,
  endDate?: string | null,
): string => {
  if (!startDate) {
    return 'Dates to be confirmed';
  }

  try {
    const start = parseISO(startDate);

    if (!endDate) {
      return format(start, 'MMM d, yyyy');
    }

    const end = parseISO(endDate);

    if (isSameDay(start, end)) {
      return format(start, 'MMM d, yyyy');
    }

    return `${format(start, 'MMM d')} – ${format(end, 'MMM d, yyyy')}`;
  } catch {
    return 'Dates to be confirmed';
  }
};